import { Component, OnInit,ChangeDetectorRef,AfterViewInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services';
import { ConstantConfigService } from 'src/app/services/constant-config.service';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();
@Component({
  selector: 'app-layout',
  templateUrl: 'layout.component.html',
  styleUrls: ['layout.component.scss']
})
export class Layout1Component implements OnInit {
  maTheme: string = this.service.maTheme
  showSidebar : boolean = false ;
  _accessToken;
  constructor(public service: AppService,
              private router: Router,
              private route: ActivatedRoute,
              private authService : AuthenticationService,
              private cdRef:ChangeDetectorRef
              ) {
                this._accessToken = ConstantConfigService.accessToken;
              }
  resolver: any;
  decodedToken : any = {};
  is_free_flow;
  ngOnInit() {
    // if(this.router.url!='/free-flow' && localStorage.getItem("free_flow")=="true" &&          localStorage.getItem(this._accessToken)!=undefined){
    //   //this.authService.logout();
    //   //localStorage.removeItem("free_flow");
    // }
    this.service.currentMessage.subscribe(message =>
      this.showSidebar = message
    )
    this.resolver = this.route.snapshot.data;
    var fullRoute = this.router.url;
    //console.log("resolver",this.resolver);
    if(this.resolver.message==true || (fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('pay') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('free-sign') > -1 || fullRoute.indexOf('download') > -1) || fullRoute.indexOf('preview-document') > -1 || fullRoute.indexOf('terms-conditions') > -1 || fullRoute.indexOf('prefill-request') > -1 || fullRoute.indexOf('approve-hubspot-properties-updation') > -1 || fullRoute.indexOf('doc-form') > -1 || fullRoute.indexOf('verifyach') > -1){

      if (fullRoute.indexOf('free-sign') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('signature') > -1  || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('pay') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1 || fullRoute.indexOf('terms-conditions') > -1 || fullRoute.indexOf('prefill-request') > -1 || fullRoute.indexOf('approve-hubspot-properties-updation') > -1 || fullRoute.indexOf('doc-form') > -1 || fullRoute.indexOf('verifyach') > -1){
        // Auth BiPass on signature compoent
        if(fullRoute.indexOf('terms-conditions') > -1){
          this.showSidebar = false;
        }
      }else{
        //alert('login redirect from layout');

        const myToken = localStorage.getItem(this._accessToken);
        if(myToken!="" && myToken!=null){
          this.decodedToken = helper.decodeToken(myToken);
          this.is_free_flow = this.decodedToken.userdata.is_free_flow;

          if(typeof this.is_free_flow!="undefined" && this.is_free_flow==1 && fullRoute.indexOf('quick-sign') > -1){
            this.router.navigate(['/quick-sign']);
          } else {
            this.router.navigate(['/login']);
          }
        } else {
          this.router.navigate(['/login']);
        }
        //this.service.geterrorMessage('Session expire!. Please login again');

      }

    }
    // else{
    //   this.authService.logout();
    //   this.router.navigate(['/login']);
    // }

  }



}
